export enum CreateGeneratedDocumentHiePdfCategory {
  Allergies = 'allergies',
  Demographics = 'demographics',
  DocumentReferences = 'document_references',
  Encounters = 'encounters',
  FamilyMemberHistories = 'family_member_histories',
  Immunizations = 'immunizations',
  Labs = 'labs',
  Medications = 'medications',
  Problems = 'problems',
  Procedures = 'procedures',
  SocialHistories = 'social_histories',
  Vitals = 'vitals',
}
